/**
 * @file: description
 * @author:
 * @Date: 2020-03-19 17:09:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-24 11:23:12
 */
import React from 'react';
import './IntegralMessage.less';
import { message } from 'antd';

export interface IIntegralMessageProps {}
type Props = IIntegralMessageProps;

const wrapper = () => (word: string, successWord: string) => {
  message.config({
    top: 100
  });
  message.destroy();

  if (word.indexOf('+') === -1) {
    return successWord ? message.success(successWord) : '';
  }

  const integralArr = word.split('，');
  const configObj = {
    content: (
      <p className={'integral-content'}>
        {integralArr[0].split('+')[0]}
        <span className="blue-content">+{integralArr[0].split('+')[1]}</span>
        积分
      </p>
    ),
    icon: <span style={{ display: 'none' }}></span>,
    onClose: () => {
      integralArr[1] &&
        message.info({
          content: (
            <p className={'integral-content-kcoin'}>
              {integralArr[1].split('+')[0]}
              <span className="blue-content">{integralArr[1].split('+')[1]}</span>
              金币
            </p>
          ),
          icon: <span style={{ display: 'none' }}></span>
        });
    }
  };

  return message.info(configObj);
};

const IntegralMessage = wrapper();
export default IntegralMessage;
